module.exports = __webpack_public_path__ + "static/media/logo-comune-frassinoro.2225c4a3.webp";